import React, { useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react"; // Iconos de flecha

export default function Carousel({ items = [], mostrarBoton = true }) {
    const swiperRef = useRef(null);

    const slideNext = () => swiperRef.current?.swiper.slideNext();
    const slidePrev = () => swiperRef.current?.swiper.slidePrev();

    useEffect(() => {
        if (swiperRef.current?.swiper && swiperRef.current.swiper.initialized) {
            swiperRef.current.swiper.slideToLoop(1, 0);
        }
    }, []);

    return (
        <div className="bg-[#e8f2f4] w-full">
            <div className="flex flex-col md:flex-row bg-[#e8f2f4] pt-8 pb-16 md:pb-20 justify-center items-center gap-6 px-4 sm:px-6">
                <div className="hidden md:flex w-1/12 justify-center">
                    <button
                        onClick={slidePrev}
                        className="bg-blue-500 text-white p-4 rounded-full hover:bg-blue-700 flex items-center justify-center"
                    >
                        <ChevronLeftIcon className="h-6 w-6" />
                    </button>
                </div>
                <div className="w-full md:w-10/12">
                    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#0346a4] mb-6 text-center max-w-4xl mx-auto px-4">
                        Al invertir con nosotros, obtienes más beneficios que al hacerlo a través de los bancos
                    </h2>
                    <Swiper
                        ref={swiperRef}
                        spaceBetween={16}
                        slidesPerView={1.05}
                        loop={true}
                        modules={[Navigation, Pagination, Autoplay]}
                        pagination={{ clickable: true }}
                        autoplay={{ delay: 6000, disableOnInteraction: false }}
                        breakpoints={{
                            640: { slidesPerView: 1.3, spaceBetween: 20 },
                            768: { slidesPerView: 2, spaceBetween: 24 },
                            1024: { slidesPerView: 3, spaceBetween: 0 },
                        }}
                        className="w-full md:ml-4 pb-2"
                        centeredSlides={true}
                    >
                        {items.map((item, index) => (
                            <SwiperSlide key={index} className="flex justify-center px-2 sm:px-4">
                                <div className="rounded-[40px] bg-white/80 w-full max-w-xs sm:max-w-sm h-72 sm:h-80 mb-10 shadow-[0_12px_18px_rgba(0,0,0,0.2)] flex flex-col justify-between p-5 pt-8 items-center text-center">
                                    <div className="flex-grow flex flex-col justify-center">
                                        <h3 className="text-lg sm:text-xl font-bold text-[#02357c]">{item.title}</h3>
                                        {item.image && <img src={item.image} alt="" className="my-2 w-16 h-auto mx-auto" />}
                                        <p className="text-sm sm:text-base font-bold text-[#0054c9] mt-2">{item.description}</p>
                                    </div>
                                    {mostrarBoton && (
                                        <button className="bg-blue-600 text-white px-4 py-2 rounded-2xl shadow-lg w-28 sm:w-32 text-sm sm:text-base">
                                            Ver más
                                        </button>
                                    )}
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                <div className="hidden md:flex w-1/12 justify-center">
                    <button
                        onClick={slideNext}
                        className="bg-blue-500 text-white p-4 rounded-full hover:bg-blue-700 flex items-center justify-center"
                    >
                        <ChevronRightIcon className="h-6 w-6" />
                    </button>
                </div>
            </div>
        </div>
    );
}
